module.exports = __webpack_public_path__ + "media/别吃鸡.824a554c.mp4";